<template>
  <div class="room ventilation" v-loading="loadingData">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="device-block-multi">
      <div class="device-block" :class="warningFlagTopLeft">
        <div class="device-block-line-chart">
          <DoubleGraph
            :opts="humidityLineOptsTopLeft"
            :series="humidityLineDataTopLeft"
          ></DoubleGraph>
        </div>
        <div class="device-block-bar-chart">
          <SinglePieHistogramWrap
            :opts="humidityBarOptsTopLeft"
            :series="humidityBarDataTopLeft"
          ></SinglePieHistogramWrap>
        </div>
      </div>

      <div class="device-block" :class="warningFlagTopRight">
        <div class="device-block-line-chart">
          <DoubleGraph
            :opts="humidityLineOptsTopRight"
            :series="humidityLineDataTopRight"
          ></DoubleGraph>
        </div>
        <div class="device-block-bar-chart">
          <SinglePieHistogramWrap
            :opts="humidityBarOptsTopRight"
            :series="humidityBarDataTopRight"
          ></SinglePieHistogramWrap>
        </div>
      </div>
    </div>

    <div class="device-block-multi">
      <div class="device-block" :class="warningFlagBottomLeft">
        <div class="device-block-line-chart">
          <DoubleGraph
            :opts="humidityLineOptsBottomLeft"
            :series="humidityLineDataBottomLeft"
          ></DoubleGraph>
        </div>
        <div class="device-block-bar-chart">
          <SinglePieHistogramWrap
            :opts="humidityBarOptsBottomLeft"
            :series="humidityBarDataBottomLeft"
          ></SinglePieHistogramWrap>
        </div>
      </div>

      <div class="device-block" :class="warningFlagBottomRight">
        <div class="device-block-line-chart">
          <DoubleGraph
            :opts="humidityLineOptsBottomRight"
            :series="humidityLineDataBottomRight"
          ></DoubleGraph>
        </div>
        <div class="device-block-bar-chart">
          <SinglePieHistogramWrap
            :opts="humidityBarOptsBottomRight"
            :series="humidityBarDataBottomRight"
          ></SinglePieHistogramWrap>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import configJson from './config/saddleRoom.json';

export default {
  name: 'ventilationNew',
  data() {
    return {
      timer: null,
      loading: false,
      loadingData: false,
      stationId1: '',
      stationId2: '',
      stationName1: '',
      stationName2: '',
      deviceList: [],

      warningFlagTopLeft: '',
      warningFlagTopRight: '',
      warningFlagBottomLeft: '',
      warningFlagBottomRight: '',

      humidityLineDataTopLeft: null,
      humidityLineDataTopRight: null,
      humidityLineDataBottomLeft: null,
      humidityLineDataBottomRight: null,
      humidityBarDataTopLeft: null,
      humidityBarDataTopRight: null,
      humidityBarDataBottomLeft: null,
      humidityBarDataBottomRight: null,
    };
  },
  computed: {
    humidityLineOptsTopLeft: function () {
      return {
        title: this.stationName1 + '上游鞍室温湿度',
        legend1: '湿度',
        legend2: '温度',
      };
    },
    humidityBarOptsTopLeft: function () {
      return {
        title: '上游鞍室温湿度',
        histogramName1: 'T',
        center1: ['52%', '60%'],
        radius1: ['40%', '55%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C',
      };
    },

    humidityLineOptsTopRight: function () {
      return {
        title: this.stationName1 + '下游鞍室温湿度',
        legend1: '湿度',
        legend2: '温度',
      };
    },
    humidityBarOptsTopRight: function () {
      return {
        title: '下游鞍室温湿度',
        histogramName1: 'T',
        center1: ['52%', '60%'],
        radius1: ['40%', '55%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C',
      };
    },

    humidityLineOptsBottomLeft: function () {
      return {
        title: this.stationName2 + '上游鞍室温湿度',
        legend1: '湿度',
        legend2: '温度',
      };
    },
    humidityBarOptsBottomLeft: function () {
      return {
        title: '上游鞍室温湿度',
        histogramName1: 'T',
        center1: ['52%', '60%'],
        radius1: ['40%', '55%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C',
      };
    },

    humidityLineOptsBottomRight: function () {
      return {
        title: this.stationName2 + '下游鞍室温湿度',
        legend1: '湿度',
        legend2: '温度',
      };
    },
    humidityBarOptsBottomRight: function () {
      return {
        title: '下游鞍室温湿度',
        histogramName1: 'T',
        center1: ['52%', '60%'],
        radius1: ['40%', '55%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C',
      };
    },
  },
  created() {
    this.readConfig();
  },
  mounted() {
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  watch: {
    /**
     * 监听路由变化
     * @param {Object} route # 当前路由信息
     */
    $route(route) {
      this.resetData();
      this.readConfig();
      this.loadingData = true;
      this.getData();
    },
  },
  methods: {
    readConfig() {
    //   const routerPath = this.$route.fullPath.split('/');
      this.deviceList = configJson.deviceList;
      // const deviceName = configJson[routerPath[3]].deviceName;
      // this.deviceLeftName = deviceName.deviceLeftName;
      // this.deviceRightName = deviceName.deviceRightName;
      this.stationId1 = configJson.stationId1;
      this.stationId2 = configJson.stationId2;
      this.stationName1 = configJson.stationName1;
      this.stationName2 = configJson.stationName2;
    },
    resetData() {
      this.warningFlagTopLeft = '';
      this.warningFlagTopRight = '';
      this.warningFlagBottomLeft = '';
      this.warningFlagBottomRight = '';
    },
    refreshData() {
      this.loadingData = true;
      this.getData();
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.getData();
      }, this.REFRESH_SECOND);
    },
    findDeviceId(deviceName) {
      const device = this.deviceList.find((el) => {
        return el.deviceName === deviceName;
      });
      if (!device) {
        console.log(`deviceName${deviceName}###`);
      }
      return device.deviceId || '';
    },
    getCurrentData(stationId) {
      return this.$http.get(`/deviceData/Station?stationId=${stationId}`);
    },
    getData() {
      this.getLineChartData();

      let requestList = [
        this.getCurrentData(this.stationId1),
        this.getCurrentData(this.stationId2),
      ];
      this.$http.all(requestList).then(
        this.$http.spread((res1, res2) => {
          setTimeout(() => {
            this.loadingData = false;
          }, 500);

          let currentData1 = res1.data;
          let currentData2 = res2.data;

          this.setPieHistogramDataAndError(
            currentData1,
            'humidityBarDataTopLeft',
            '黄石侧上游鞍室温度',
            '黄石侧上游鞍室湿度',
            'warningFlagTopLeft'
          );
          this.setPieHistogramDataAndError(
            currentData1,
            'humidityBarDataTopRight',
            '黄石侧下游鞍室温度',
            '黄石侧下游鞍室湿度',
            'warningFlagTopRight'
          );

          this.setPieHistogramDataAndError(
            currentData2,
            'humidityBarDataBottomLeft',
            '黄冈侧上游鞍室温度',
            '黄冈侧上游鞍室湿度',
            'warningFlagBottomLeft'
          );
          this.setPieHistogramDataAndError(
            currentData2,
            'humidityBarDataBottomRight',
            '黄冈侧下游鞍室温度',
            '黄冈侧下游鞍室湿度',
            'warningFlagBottomRight'
          );
        })
      );
    },

    getLineChartData() {
      let temperatureDeviceName = '黄石侧上游鞍室温度';
      let humidityDeviceName = '黄石侧上游鞍室湿度';
      this.$http
        .all([
          this.getStatisticsData(this.findDeviceId(temperatureDeviceName)),
          this.getStatisticsData(this.findDeviceId(humidityDeviceName)),
        ])
        .then(
          this.$http.spread((temperaturePromise, humidityPromise) => {
            this.setLineData(
              temperaturePromise,
              humidityPromise,
              'humidityLineDataTopLeft',
              'warningFlagTopLeft'
            );
          })
        );

      temperatureDeviceName = '黄石侧下游鞍室温度';
      humidityDeviceName = '黄石侧下游鞍室湿度';
      this.$http
        .all([
          this.getStatisticsData(this.findDeviceId(temperatureDeviceName)),
          this.getStatisticsData(this.findDeviceId(humidityDeviceName)),
        ])
        .then(
          this.$http.spread((temperaturePromise, humidityPromise) => {
            this.setLineData(
              temperaturePromise,
              humidityPromise,
              'humidityLineDataTopRight',
              'warningFlagTopRight'
            );
          })
        );

      temperatureDeviceName = '黄冈侧上游鞍室温度';
      humidityDeviceName = '黄冈侧上游鞍室湿度';
      this.$http
        .all([
          this.getStatisticsData(this.findDeviceId(temperatureDeviceName)),
          this.getStatisticsData(this.findDeviceId(humidityDeviceName)),
        ])
        .then(
          this.$http.spread((temperaturePromise, humidityPromise) => {
            this.setLineData(
              temperaturePromise,
              humidityPromise,
              'humidityLineDataBottomLeft',
              'warningFlagBottomLeft'
            );
          })
        );

      temperatureDeviceName = '黄冈侧下游鞍室温度';
      humidityDeviceName = '黄冈侧下游鞍室湿度';
      this.$http
        .all([
          this.getStatisticsData(this.findDeviceId(temperatureDeviceName)),
          this.getStatisticsData(this.findDeviceId(humidityDeviceName)),
        ])
        .then(
          this.$http.spread((temperaturePromise, humidityPromise) => {
            this.setLineData(
              temperaturePromise,
              humidityPromise,
              'humidityLineDataBottomRight',
              'warningFlagBottomRight'
            );
          })
        );
    },

    setPieHistogramDataAndError(
      currentData,
      echartSeriesDataName,
      temperatureName,
      humidityName,
      warningFlagName
    ) {
      const temperatureId = this.findDeviceId(temperatureName);
      const humidityId = this.findDeviceId(humidityName);
      this[echartSeriesDataName] = {
        data1: currentData[temperatureId].value,
        data2: currentData[humidityId].value,
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(
        currentData[temperatureId].errorLevel,
        this[warningFlagName]
      );
      errorLevel = this.getErrorLevelFromMultipleDevice(
        currentData[humidityId].errorLevel,
        this[warningFlagName]
      );
      this[warningFlagName] = errorLevel;
    },

    setLineData(
      temperatureData,
      humidityData,
      echartSeriesDataName,
      warningFlagName
    ) {
      let data1 = {};
      let data2 = {};
      temperatureData.data.dataList.forEach((item, index) => {
        data1[item.StatisticsDate] = item.value;
      });
      humidityData.data.dataList.forEach((item, index) => {
        data2[item.StatisticsDate] = item.value;
      });

      this[echartSeriesDataName] = {
        data1: data1,
        data2: data2,
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(
        temperatureData.data.errorLevel,
        this[warningFlagName]
      );
      errorLevel = this.getErrorLevelFromMultipleDevice(
        humidityData.data.errorLevel,
        this[warningFlagName]
      );
      this[warningFlagName] = errorLevel;
    },

    getStatisticsData(deviceId) {
      return this.$http.get(
        '/statistics/DeviceData?deviceId=' +
          deviceId +
          '&interval=BY_HOUR&insertBlankData=true'
      );
    },

    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === 'Error') {
        return 'Error';
      } else if (currentErrorLevel === 'Warning') {
        if (newErrorLevel === 'Error') {
          return 'Error';
        } else {
          return 'Warning';
        }
      } else {
        return newErrorLevel;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ventilation {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  padding-top: 10px;

  .device-block-multi {
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    align-items: stretch;

    .device-block {
      width: calc(50% - 10px);
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      position: relative;

      .device-block-line-chart {
        width: 75%;
        height: 100%;
      }

      .device-block-bar-chart {
        width: 24%;
        height: 100%;
      }
    }
  }

  .device-block-line {
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    align-items: stretch;

    .device-block-line-item {
      width: calc(50% - 9px);
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      flex-direction: column;
      align-items: stretch;

      .device-block-line-item-half {
        display: flex;
        height: 100%;
        width: calc(50% - 7px);
        flex-direction: column;
        justify-content: space-between;
      }

      .device-block-line-item-top {
        display: flex;
        justify-content: space-between;
        height: 60px;
        width: 100%;
      }

      .switch-item {
        height: 38px;
        width: 100%;
        box-sizing: border-box;
        flex-shrink: 0;
        margin-bottom: 10px;
        &:last-child {
          margin-bottom: 0;
        }
      }

      .running-time-item-left {
        height: calc(100% - 290px);
        width: 100%;
        box-sizing: border-box;
      }

      .running-time-item-right {
        height: calc(100% - 240px);
        width: 100%;
        box-sizing: border-box;
      }

      &.single-chart-item {
        background-color: rgba(255, 255, 255, 0.6);
      }
    }
  }

  .air-wrap {
    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    padding: 0 10px;
    width: calc(50% - 10px);
    height: 100%;
    background-color: rgba(255, 255, 255, 0.6);
    box-sizing: border-box;

    .air-title {
      padding: 20px 15px 10px 10px;
      font-size: 22px;
      color: #515151;
    }

    .air-chart-wrap {
      display: flex;
      flex: 1;
    }

    .air-chart {
      padding: 20px 0;
      box-sizing: border-box;
      width: 33.3333%;

      .device-block-multi-item {
        width: calc((100% / 3) - 10px);
        background-color: rgba(255, 255, 255, 0.6);
      }
    }
  }
}
</style>
